import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6311141d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"border-bottom":"1px solid #e5e5e5","padding-bottom":"10px"} }
const _hoisted_2 = { class: "badge-patent" }
const _hoisted_3 = { class: "badge-1" }
const _hoisted_4 = { class: "badge-2" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "part1 d-flex van-row--align-center van-row--justify-center" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "part2 d-flex van-row--align-center van-row--justify-center" }
const _hoisted_9 = { class: "quantity" }


import { useRouter } from 'vue-router'

import runEvn from "@/modular/runEvn/RunEvn";

export default /*#__PURE__*/_defineComponent({
  __name: 'cloudClassItem',
  props: {
    itemData: Object,
},
  setup(__props) {

const fileBaseUrl = runEvn().fileBaseUrl;
const router = useRouter();

const props = __props;

function goDetails() {
    router.push({
        path: `/mulin/cloudClass/Detail/${props.itemData.id}`,
    });
}

const longNumberFormat = (text: any) => {
    if (typeof text === "string") {
        text = Number(text);
    }
    if (text >= 1000 && text < 10000) {
        text = text / 1000;
        text = text.toString();
        text = text.substr(0, text.length - 1);
        return text + " 千";
    }
    if (text >= 10000) {
        text = text / 10000;
        text = text.toString();
        text = text.substr(0, text.length - 2);
        return text + " 万";
    } else {
        return text + " ";
    }
}


const img = (key: string) => fileBaseUrl + key;

return (_ctx: any,_cache: any) => {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_RatioHeightContainer = _resolveComponent("RatioHeightContainer")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", {
    class: "item",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (goDetails()))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_RatioHeightContainer, { ratio: 54.49 }, {
        default: _withCtx(() => [
          _createVNode(_component_van_image, {
            class: "item_image",
            width: "100%",
            height: "100%",
            alt: "图片加载中...",
            fit: "cover",
            round: "",
            src: __props.itemData.coverUrl
          }, null, 8, ["src"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(__props.itemData.mainCategory), 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.itemData.subCategory), 1)
      ]),
      _createElementVNode("div", _hoisted_5, _toDisplayString(__props.itemData.title), 1),
      _createVNode(_component_van_row, {
        type: "flex",
        class: "desc"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_van_image, {
              class: "image",
              alt: "图片加载中...",
              radius: "50%",
              fit: "cover",
              src: img(__props.itemData.userImageUrl)
            }, null, 8, ["src"]),
            _createElementVNode("span", _hoisted_7, _toDisplayString(__props.itemData.userName || "匿名用户"), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", _hoisted_9, _toDisplayString(longNumberFormat(
                                __props.itemData.visitsCount
                            )) + "人已看", 1)
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})